import React, { useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';
import { UserInterface } from '../../../../../core/components/user/domain/interfaces/user_interface';
import ThemeConstants from '../../../../../config/theme/theme_constants';
import LockIcon from '../../../../../assets/images/lock_icon.svg?react';
import UvibesPoint from '../../../../../assets/images/uvibes_point.svg?react';
import { useTranslation } from '../../../../../i18n/useTranslation';

const LockCard: React.FC = () => {
  const { t } = useTranslation();
  const theme = ThemeConstants();
  const { experience, company } = useOutletContext<UserInterface>();

  const requiredExp = useMemo(() => {
    return company?.limits?.pointsCareerOpen || 50;
  }, [company?.limits?.pointsCareerOpen]);

  const totalExperience = useMemo(() => {
    if (experience.totalExp <= requiredExp) {
      return experience.totalExp;
    }
    return requiredExp;
  }, [experience.totalExp, requiredExp]);

  return (
    <div className="flex fixed top-0 left-0 justify-center items-center w-dvw h-dvh z-1 bg-black/80">
      <div className="bg-white max-sm:w-[65%] rounded-3xl flex flex-col justify-between items-center px-5 pb-10.5 pt-8 gap-16">
        <h2 className="text-2xl font-bold text-center">{t('course.lock.title')}</h2>
        <div className='w-full flex flex-col items-center gap-11.5'>
          <div className="w-full flex flex-col items-center gap-3.5">
            <LockIcon className='w-10 h-10' color="black"/>
            <div className="gap-3 w-full flex items-center">
              <div
                className="h-2.5 bg-transparent border rounded-full w-full"
                style={{ borderColor: theme.UvibesBlue }}
                >
                <div
                  className="h-full rounded-full"
                  style={{
                    width: `${(totalExperience / requiredExp) * 100}%`,
                    backgroundColor: theme.UvibesBlue,
                  }}
                />
              </div>
              <p className="font-bold py-1.25">{totalExperience}/{requiredExp}</p>
            </div>
          </div>
          <p className="text-sm font-normal">
            {t('course.lock.hint', { points: requiredExp })}{' '}<UvibesPoint className='inline w-4.5 h-4.5'/>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LockCard;
